import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const SubScriptWrap = styled.div`
  display: block;
  min-width: 328px;
  ${customMedia.lessThan('tablet')`
    margin: 0 auto;
    max-width: 600px;
    width:100%;
  `}
`
const SubScriptTitle = styled.h3`
  font-size: 24px;
  line-height: 35px;
  font-family: NotoSansBold, sans-serif;
  white-space: pre-line;
  margin: 62px 0 12px 0;
  color: ${COLOR.black};
  ${customMedia.lessThan('tablet')`
      margin: 25px 0 8px 0;  
      font-size: 16px;
      line-height: 23px;
  `}
`
const SubScriptDesc = styled.div`
  margin: 0 0 105px 0;

  > p {
    white-space: pre-line;
    line-height: 20px;
    font-size: 14px;
    font-family: NotoSansRegular, sans-serif;
    color: ${COLOR.point1};
  }

  ${customMedia.lessThan('tablet')`
    margin: 0 0 54px 0;
    max-width: 600px;
    width: 100%;
    >p{
     font-size: 12px;
     line-height: 17px;   
    }
  `}

  ${customMedia.lessThan('mobile')`
    margin: 0 0 26px 0;
  `}
`

const SubScriptContent = styled.div`
  width: 600px;
  margin: 0 auto;
  display: block;
  ${customMedia.lessThan('tablet')`
    max-width: 600px;
    width: 100%;
  `}
`
const TelChoiceTabWrap = styled.div`
  margin: 0 auto 24px auto;
  ${customMedia.lessThan('tablet')`
    margin: 0 auto 24px auto;
    max-width:600px;
    width: 100%;
  `}
`
const TelecomBtn = styled.button<{ borderRadius: string; active: string }>`
  display: inline-block;
  width: 200px;
  height: 53px;
  box-sizing: border-box;
  cursor: ${(props) => (props.active === 'true' ? 'default' : 'pointer')};
  font-size: 18px;
  line-height: 20px;
  background: ${(props) => (props.active === 'true' ? COLOR.point1 : COLOR.white)};
  border-radius: ${(props) => props.borderRadius};
  border: ${(props) => (props.active === 'true' ? 'none' : `1px solid ${COLOR.point1}`)};
  color: ${(props) => (props.active === 'true' ? COLOR.white : COLOR.point1)};
  font-family: NanumSquareNeoHeavy, sans-serif;
  &:disabled {
    background: ${(props) => (props.active === 'true' ? COLOR.gray30 : COLOR.white)};
    border: ${(props) => (props.active === 'true' ? 'none' : `1px solid ${COLOR.gray30}`)};
    color: ${(props) => (props.active === 'true' ? COLOR.white : COLOR.gray30)};
  }
  ${customMedia.lessThan('tablet')`
    height: 40px;
    font-size: 14px;
    line-height: 20px;
    width: 33%;
    max-width: 200px;
  `}
`

export {
  SubScriptContent,
  SubScriptDesc,
  SubScriptTitle,
  SubScriptWrap,
  TelChoiceTabWrap,
  TelecomBtn,
}
